import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Globals, Constants, Permissions } from 'utils';
import Header from './header';
import $ from 'jquery';
import { Logo, LogoIcon } from 'assets/img';
import { ArrowUp, ArrowBottom, Menu as MenuIcons, MenuIcon, MenuOpenIcon, MenuCloseIcon } from 'assets/icons';

interface MenuItem {
	name: string;
	path: string;
	submenu?: MenuItem[];
	icon?: string;
	permission?: string;
	onClick?: () => void;
	iconActive?: string;
	code: string;
	isLogout?: boolean;
	plan_permission?: number;
}

const PLAN_PERMISSIONS = {
	KYC: 'has_kyc_plan',
	DOCUMENTS: 'has_document_plan',
	BILLS: 'has_bill_plan'
}

class Menu extends React.Component<any> {

	state: any = {
		leftOpen: this.props.sidebar,
		openResponsive: false,
		items: [
			{ name: 'Dashboard', path: '/admin/home', icon: MenuIcons.Menu1, permission: Constants.MODULES.ADMIN_HOME },
			{ name: 'Usuarios', path: '/admin/users', icon: MenuIcons.Menu3, permission: Constants.MODULES.USERS },
			{ name: 'Planes', path: '/admin/plans', icon: MenuIcons.Menu4, permission: [
				Constants.MODULES.VERIFICATION_PLANS,
				Constants.MODULES.DOCUMENT_PLANS
			], submenu: [
				{ name: 'Planes de Verificaciones', path: '/admin/plans/verifications', permission: Constants.MODULES.VERIFICATION_PLANS, icon: MenuIcons.Menu9 },
				{ name: 'Planes de Documentos', path: '/admin/plans/documents', permission: Constants.MODULES.DOCUMENT_PLANS, icon: MenuIcons.Menu5 },
				{ name: 'Planes de Facturas', path: '/admin/plans/bills', permission: Constants.MODULES.BILL_PLANS, icon: MenuIcons.Menu6 },
			] },
			{ name: 'Modulo facturas', path: '/admin/bills', icon: MenuIcons.Menu6, permission: Constants.MODULES.ADMIN_BILLS, submenu: [
				{ name: 'Reporte de facturas', path: '/admin/bills/report', icon: MenuIcons.Menu17 },
				{ name: 'Subir facturas', path: '/admin/bills/upload', icon: MenuIcons.Menu15 },
				{ name: 'Exportar datos', path: '/admin/bills/export', icon: MenuIcons.Menu14 },
				{ name: 'Empresa', path: '/admin/bills/company', icon: MenuIcons.Menu16 },
				{ name: 'Configuración', path: '/admin/bills/config/', permission: Constants.MODULES.ADMIN_CONFIG, icon: MenuIcons.Menu8 }
			] },
			{ name: 'KYC', path: '/admin/verifications', icon: MenuIcons.Menu9, permission: [
				Constants.MODULES.ADMIN_KYC,
				Constants.MODULES.ADMIN_BLACK_LIST
			], submenu: [
				{ name: 'Reporte de Verificaciones', path: '/admin/verifications/report', permission: Constants.MODULES.ADMIN_KYC, icon: MenuIcons.Menu12 },
				{ name: 'Lista Negra', path: '/admin/verifications/black-list', permission: Constants.MODULES.ADMIN_BLACK_LIST, icon: MenuIcons.Menu13 },
				{ name: 'Configuración', path: '/admin/verifications/config', permission: Constants.MODULES.ADMIN_CONFIG, icon: MenuIcons.Menu8 },
			] },
			{ name: 'Documentos', path: '/admin/documents', icon: MenuIcons.Menu5, permission: Constants.MODULES.ADMIN_DOCUMENTS, submenu: [
				{ name: 'Reporte de Documentos', path: '/admin/documents/report', icon: MenuIcons.Menu11 },
				{ name: 'Configuración', path: '/admin/documents/config', permission: Constants.MODULES.ADMIN_CONFIG, icon: MenuIcons.Menu8 },
			] },
			{ name: 'Auditoría', path: '/admin/system-movements', icon: MenuIcons.Menu10, permission: Constants.MODULES.ADMIN_SYSTEM_MOVEMENTS },
			{ name: 'Moderadores', path: '/admin/moderators', icon: MenuIcons.Menu7, permission: Constants.MODULES.ADMIN_MODERATORS },
		],
		items_client: [
			{ name: 'Dashboard', path: '/client/home', icon: MenuIcons.Menu1, permission: Constants.MODULES.GRAPHICS },
			{ name: 'Modulo facturas', path: '/client/bills', icon: MenuIcons.Menu6, permission: Constants.MODULES.BILLS, plan_permission: PLAN_PERMISSIONS.BILLS, submenu: [
				{ name: 'Reporte de facturas', path: '/client/bills/report', icon: MenuIcons.Menu17 },
				{ name: 'Subir facturas', path: '/client/bills/upload', icon: MenuIcons.Menu15 },
				{ name: 'Exportar datos', path: '/client/bills/export', icon: MenuIcons.Menu14 },
				{ name: 'Empresa', path: '/client/bills/company', icon: MenuIcons.Menu16 },
				{ name: 'Configuración', path: '/client/bills/config', permission: Constants.MODULES.CONFIG, icon: MenuIcons.Menu8 },
			] },
			{ name: 'KYC', path: '/client/verifications', icon: MenuIcons.Menu9, plan_permission: PLAN_PERMISSIONS.KYC, permission: [
				Constants.MODULES.KYC,
				Constants.MODULES.BLACK_LIST
			], submenu: [
				{ name: 'Reporte de Verificaciones', path: '/client/verifications/report', permission: Constants.MODULES.KYC, icon: MenuIcons.Menu12 },
				{ name: 'Lista Negra', path: '/client/verifications/black-list', permission: Constants.MODULES.BLACK_LIST, icon: MenuIcons.Menu13 },
				{ name: 'Configuración', path: '/client/verifications/config', permission: Constants.MODULES.CONFIG, icon: MenuIcons.Menu8 },
			] },
			{ name: 'Documentos', path: '/client/documents', icon: MenuIcons.Menu5, permission: Constants.MODULES.DOCUMENTS, plan_permission: PLAN_PERMISSIONS.DOCUMENTS, submenu: [
				{ name: 'Reporte de Documentos', path: '/client/documents/report', icon: MenuIcons.Menu11 },
				{ name: 'Configuración', path: '/client/documents/config', permission: Constants.MODULES.CONFIG, icon: MenuIcons.Menu8 },
			] },
			{ name: 'Auditoría', path: '/client/system-movements', permission: Constants.MODULES.SYSTEM_MOVEMENTS, icon: MenuIcons.Menu10 },
			{ name: 'Moderadores', path: '/client/moderators', icon: MenuIcons.Menu7, permission: Constants.MODULES.MODERATORS },
			{ name: 'Integración API', path: '/client/config/api', permission: Constants.MODULES.CONFIG, icon: MenuIcons.Menu2 },
		]
	}

	toggleSidebar = () => {
	    let key: any = `leftOpen`;
	    // @ts-ignore
	    this.setState({ [key]: !this.state[key] },() => {
	    	this.props.dispatch({
	    		type: 'SET_SIDEBAR',
	    		payload: this.state.leftOpen
	    	});
	    });
	}

	checkActive = (value: string, current: string) => {
		return current.includes(value);
	}

	changeMenu = (item: MenuItem) => {
		if (item.submenu && !this.state.leftOpen) {
			this.toggleSidebar();
		}
	}

	checkPermission = (item: any) => {
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.CLIENT) {
			return true;
		}
		const permissions = this.props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];
		if (Array.isArray(item.permission)) {
			let _continue = false;
			item.permission.forEach((i: any) => {
				if (permissions.indexOf(i) != -1) {
					_continue = true;
				}
			});
			return _continue;
		}
		else {
			return permissions.indexOf(item.permission) != -1;
		}		
	}

	closeNavbar = () => {
		// @ts-ignore
		$('#collapsibleNavbar').collapse('hide');
	}

	toggleResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	closeResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	render() {
		let leftOpen = !this.props.isAuth && this.state.leftOpen ? "open" : "closed";
		let items = [];

		if (this.props.user) {
			switch(this.props.user?.level_id) {
				case Constants.LEVELS.ADMIN:
					items = this.state.items;
				break;

				case Constants.LEVELS.MODERATOR:
					items = this.state.items;
				break;

				case Constants.LEVELS.CLIENT:
					items = this.state.items_client;
				break;

				case Constants.LEVELS.CLIENT_MODERATOR:
					items = this.state.items_client;
				break;
			}
		}

		return (
			<React.Fragment>
				{/*{
					items.length > 0 && (
						<nav className="navbar navbar-expand-lg bg-dark navbar-dark fixed-top justify-content-start">
						  <button className="navbar-toggler" type="button" onClick={ this.toggleResponsive }>
						    <img src={ MenuIcon } />
						  </button>
					    </nav>
					)
				}*/}

				<div id="left" className={ leftOpen }>
					<div className={`sidebar ${ leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '') }`}>
						<div className={ `shadow-close ${ this.state.openResponsive ? 'open' : '' }` } onClick={ this.closeResponsive }></div>
						<div className="container-menu">
							<div className={ `menu ${ leftOpen }` }>
								<div className="container-scroll">
									<div className="container-logo">
										<img src={ this.state.leftOpen ? Logo : LogoIcon } className={ this.state.leftOpen ? '' : 'logo-responsive' } />
									</div>
									<div className="container-menu-toggler">
										<button className={ `navbar-toggler navbar-toggler-menu ${ leftOpen }` } type="button" onClick={ () => {
											this.toggleSidebar();
										} }>
										    <img src={ MenuIcon } />
										</button>
										<button className={ `navbar-toggler navbar-toggler-menu responsive ${ leftOpen }` } type="button" onClick={ () => {
											this.toggleResponsive();
										} }>
										    <img src={ MenuIcon } />
										</button>
										<p>Menú Principal</p>
									</div>									
									<ul className={ leftOpen }>
										{ items.map((i: MenuItem,index: number) => {
											if (i.plan_permission && !this.props.user[i.plan_permission]) {
												return;
											}

											return (
												<React.Fragment key={ index }>
													{
														(!i.permission || this.checkPermission(i)) && (
															<>
																<li className={ `nav-item ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																	<Link to={ i.path } className={ `${ i.submenu && i.submenu.length > 0 ? 'contain-submenu' : '' }` } onClick={ (e: any) => {
																		if (i.onClick) {
																			e.preventDefault();
																			i.onClick();
																		}
																		else {
																			if (i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) && this.props.open_menu) {
																				this.props.dispatch({
																					type: 'SET_OPEN_MENU',
																					payload: false
																				});
																				e.preventDefault();
																			}
																			else {
																				this.props.dispatch({
																					type: 'SET_OPEN_MENU',
																					payload: true
																				});
																				this.changeMenu(i);
																				this.closeResponsive();
																			}
																		}																	
																	} }>
																		<div className={ `container-icon-menu ${ leftOpen } ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																			{
																				i.icon && (
																					<img src={ i.icon } />
																				)
																			}
																		</div>												
																		<span className={ leftOpen }>
																			{ i.name }
																			{/*{
																				i.submenu && i.submenu.length > 0 && (
																					<React.Fragment>
																						{
																							this.checkActive(i.path,this.props.history.location.pathname) ? (
																								<img className="arrow-drop" src={ this.props.open_menu ? ArrowUp : ArrowBottom } />
																							) : (
																								<img className="arrow-drop" src={ ArrowBottom } />
																							)
																						}
																					</React.Fragment>
																				)
																			}*/}
																		</span>
																	</Link>
																	{
																		this.props.open_menu && (
																			<div className={ `${ i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) ? 'container-submenu' : '' }` }>
																				<div className="line"></div>
																				{
																					leftOpen != 'closed' && this.checkActive(i.path,this.props.history.location.pathname) && i.submenu && i.submenu.map((item: MenuItem,index: number) => {
																						if (!item.permission || this.checkPermission(item)) {
																							return (
																								<li className={ 'nav-item item-submenu ' + (this.props.history.location.pathname == item.path ? 'active' : '') }>
																									<Link to={ item.path } className="submenu">
																										{
																											item.icon && (
																												<img src={ item.icon } />
																											)
																										}
																										{ item.name }
																									</Link>
																								</li>
																							)
																						}
																					})
																				}
																			</div>
																		)
																	}
																</li>
																<div className="nav-item-divider"></div>
															</>
														)
													}												
												</React.Fragment>
											)
										}) }
									</ul>
								</div>
							</div>
						</div>
						<div className={ `container-router ${ leftOpen }` }>
							<Header className={ leftOpen + ' ' + (items.length > 0 && 'header-responsive') } toggleSidebar={ () => this.toggleSidebar() } toggleResponsive={ () => this.toggleResponsive() } />
							<div className={ `container-padding-router ${ items.length > 0 && 'container-responsive' }` }>{ this.props.children }</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default connect((state: any) => {
	return {
		user: state.user,
		open_menu: state.open_menu,
		sidebar: state.sidebar
	}
})(Menu);